import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
  PLATFORM_ID,
  Inject,
  AfterViewInit,
} from '@angular/core';
import { getDataCampaign } from '@utils/get-campaign';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@enviroment/environment';
import { Subject, takeUntil } from 'rxjs';
import { ScreenService } from '@utils/screen';

@Component({
  selector: 'app-input-otp',
  templateUrl: './input-otp.component.html',
  styleUrl: './input-otp.component.css',
})
export class InputOtpComponent implements AfterViewInit {
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;
  @Input() submitted: any;
  @Output() InputOTP_Emit: EventEmitter<any> = new EventEmitter<any>();

  env: any = environment;

  OTPlength: number = 6;
  inputs: number[] = [];
  otp: string[] = [];
  getCampaign: any = {};

  private destroy$ = new Subject<void>();
  resolution: number = 0;

  constructor(
    public _getDataCampaign: getDataCampaign,
    private _screenService: ScreenService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this._getDataCampaign.getCampaignDataUpdates().subscribe((data) => {
      this.getCampaign = data;
    });

    this.isMobileSubscribe();

    if (this.env.BRAND == 'coltefinanciera') {
      this.OTPlength = 4; // Coltefinanciera uses a 4-digit OTP
    }

    this.inputs = Array.from({ length: this.OTPlength }, (_, i) => i);
    this.otp = Array.from({ length: this.OTPlength }, () => '');
  }

  ngAfterViewInit() {
    // Auto-focus en el primer input cuando el componente se inicializa
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        if (this.otpInputs && this.otpInputs.length > 0) {
          const firstInput = this.otpInputs.first.nativeElement;
          firstInput.focus();
          // Si es mobile (resolution == 2), abrir el teclado virtual
          if (this.resolution === 2) {
            // Para asegurar que el teclado se abra, selecciona el input y dispara un evento de touch/click
            firstInput.select && firstInput.select();
            // Dispara un evento de touch/click para forzar el teclado en algunos navegadores móviles
            const event = new Event('touchstart', { bubbles: true });
            firstInput.dispatchEvent(event);
          }
        }
      }, 400);
    }
  }

  isMobileSubscribe() {
    this._screenService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((screen) => {
      this.resolution = screen;
    });
  }

  onOtpChange(event: any, index: number) {
    const otpValue = event.target.value;
    // Actualiza el valor correspondiente en el array this.otp
    this.otp[index] = otpValue;
    // Si se elimina el contenido del campo
    if (otpValue === '') {
      // Mantiene el foco en el mismo campo de entrada
      event.target.focus();
    } else {
      // Mueve el foco al siguiente campo si no está completo
      if (index < this.OTPlength - 1) {
        this.otpInputs.toArray()[index + 1].nativeElement.focus();
      } else {
        // Si es el ultimo input, retiramos el foco, es decir hacemos blur para emitir
        this.otpInputs.toArray()[this.OTPlength - 1].nativeElement.blur();
      }
    }
  }

  onValidateEmit() {
    let otp_lenth = this.getOtpLength();
    let emit_obj = {
      validate: false,
      otp: '',
    };
    emit_obj.validate = otp_lenth === this.OTPlength;
    emit_obj.otp = this.otp.join('');
    this.InputOTP_Emit.emit(emit_obj);
  }

  getOtpLength() {
    return this.otp.filter((item) => item !== '').length;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Backspace') {
      const input = event.target as HTMLInputElement;
      if (input.value === '') {
        const index = this.otpInputs.toArray().findIndex((x) => x.nativeElement === input);
        if (index > 0) {
          this.otpInputs.toArray()[index - 1].nativeElement.focus();
        }
      }
    }
  }

  onlyNumber(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  onFocus(index: number) {
    if (this.otp.length > index) {
      this.otpInputs.toArray()[index].nativeElement.select();
    }
  }

  validEmptyInput(value: any) {
    return !(value === '' || value === null || value === undefined);
  }

  onPaste(event: ClipboardEvent): void {
    if (isPlatformBrowser(this.platformId)) {
      event.preventDefault();
      const clipboardData: DataTransfer = event.clipboardData || (window as any).clipboardData;
      const pastedData: string = clipboardData.getData('text');

      if (pastedData.length === this.OTPlength && /^\d+$/.test(pastedData)) {
        for (let i = 0; i < this.OTPlength; i++) {
          this.otp[i] = pastedData.charAt(i);
          const inputElement = this.otpInputs.toArray()[i].nativeElement;
          inputElement.value = pastedData.charAt(i);
        }
        this.otpInputs.forEach((input) => input.nativeElement.blur());
      }
    }
  }
}
